import { inject } from 'mobx-react';
import { AssistanceDrawerComponent } from './component';
export const AssistanceDrawer = inject(({ assistance }) => ({
    status: assistance.status,
    availableUpdates: assistance.availableUpdates,
    clearedFiltersCount: assistance.clearedFiltersCount,
    reauthenticate: assistance.reauthenticate,
    clearCache: assistance.clearCache,
    resetLocal: assistance.resetLocal,
    updatePackages: assistance.updatePackages,
    clearFilters: assistance.clearFilters,
    copyUserInfo: assistance.copyUserInfo,
}))(AssistanceDrawerComponent);
//# sourceMappingURL=index.js.map